const items = [
    {
        id: "1",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941245/foto_hp_8.jpg",
        height: 750,
        position: "50% 10%",
    },
    {
        id: "12",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941243/foto_hp_7.jpg",
        height: 900,
        position: "50% 40%",
        title: "Festivais",
        url: "https://dodofestival.netlify.app/",
        titlePosition: {
            top: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
        },
    },
    {
        id: "8",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941242/foto_hp_6.jpg",
        height: 300,
        position: "50% 40%",
        title: "Ensaios",
        url: "/ensaios",
        titlePosition: {
            top: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
        },
    },
    {
        id: "2",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941241/foto_hp_5.jpg",
        height: 250,
        position: "bottom",
    },
    {
        id: "3",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941246/foto_hp_10.jpg",
        height: 652,
    },
    {
        id: "4",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941704/foto_hp_13.jpg",
        height: 300,
        position: "50% 10%",
    },
    {
        id: "5",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941513/foto_hp_12.jpg",
        height: 652,
        position: "50% 30%",
        url: "/fotosSoltas",
        title: "Recordações",
        titlePosition: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
        },
    },
    {
        id: "6",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941238/foto_hp_1.jpg",
        height: 600,
        position: "50% 30%",
        url: "/testemunhos",
        title: "In Vino Veritas",
        titlePosition: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            lineHeight: "17px",
        },
    },
    {
        id: "7",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941240/foto_hp_4.jpg",
        height: 652,
        position: "50% 30%",
        url: "/direcao",
        title: "Direção",
        titlePosition: {
            top: "60%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
        },
    },

    {
        id: "10",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941802/foto_hp_14.jpg",
        height: 550,
        position: "50% 40%",
        title: "Cronologia",
        url: "/Cronologia",
        titlePosition: {
            top: "80%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
        },
    },

    {
        id: "11",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941949/foto_hp_15.jpg",
        height: 600,
        position: "50% 40%",
    },

    {
        id: "9",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941239/foto_hp_3.jpg",
        height: 450,
        position: "50% 40%",
    },

    {
        id: "13",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941248/foto_hp_11.jpg",
        height: 550,
    },
    {
        id: "14",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941246/foto_hp_9.jpg",
        height: 500,
        position: "top",
    },
    {
        id: "16",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763941238/foto_hp_2.jpg",
        height: 500,
    },
];

export default items;
